import gsap from 'gsap'
import {awdScroll, winsize} from './bundle.js'

class NavigationBar{
    constructor(container, direction = 'vertical'){
        this.container = container
        this.navigation = container.querySelector('.navigation')
        this.navigationCursor = this.navigation.querySelector('.navigation__cursor')
        this.navigationSections = [...this.navigation.querySelectorAll('.navigation__section')]
        this.sections = [...container.querySelectorAll('.sezione-navigation')]
        this.sectionTarget = this.sections[0]
        this.direction = direction
        this.isAnimating = false


        if(this.direction === 'horizontal'){
            this.cursorDestinations = {}
            this.offsets = {}
            this.sectionsWidths = {}
            this.navigationSections.forEach( navigationSection => {
                let dataNavigation = navigationSection.getAttribute('data-navigation')
                let rect = navigationSection.getBoundingClientRect()
                let position = rect.left + rect.width/2
                this.cursorDestinations[dataNavigation] = position
            })
            this.sections.forEach( (section, i) => {
                this.offsets[i] = section.getBoundingClientRect().left
            })
            const keys = Object.keys(this.offsets);
            keys.forEach( (key, i) => {
                if(i+1 < keys.length){
                    this.sectionsWidths[i] = this.offsets[i+1] - this.offsets[i]
                }
                else{
                    this.sectionsWidths[i] = winsize.width
                }
            })
            // console.log(this.sectionsWidths)
        }
        this.initEvents()
    }

    initEvents(){
        if(this.direction === 'horizontal'){
            this.onResize()
        }
        this.moveCursor()
        this.setInviewOnClick()
        if(this.direction === 'vertical'){
            this.setInviewOnVerticalScroll()
            awdScroll.on('scroll', () => {
                if(!document.querySelector('body').classList.contains('click-on-navigation')){
                    // this.moveCursor()
                    this.setInviewOnVerticalScroll()
                }
            })
        }
        else{
            this.setInviewOnHorizontalScroll()
            awdScroll.on('scroll', () => {
                if(!document.querySelector('body').classList.contains('click-on-navigation')){
                    // this.moveCursor()
                    this.setInviewOnHorizontalScroll()
                }
            })
        }
    }

    onResize(){
        window.addEventListener('resize', () => {
            this.navigationSections.forEach( navigationSection => {
                let dataNavigation = navigationSection.getAttribute('data-navigation')
                let rect = navigationSection.getBoundingClientRect()
                let position = rect.left + rect.width/2
                this.cursorDestinations[dataNavigation] = position
            })            
            this.moveCursor()
        })
    }

    setInviewOnVerticalScroll(){
        this.sections.forEach( section => {
            let offset = winsize.height*0.15
            const sectionHeight = section.getBoundingClientRect().height
            const top = section.getBoundingClientRect().top
            let dataNavigation = section.getAttribute('data-navigation')
            //Funzione principale
            if(top < winsize.height - offset && top+sectionHeight >= winsize.height - offset){
                section.classList.add('inview')
                this.sectionTarget = section
                this.container.querySelector('.navigation__section[data-navigation="'+dataNavigation+'"]').classList.add('active')
                this.moveCursor()
            }
            else{
                section.classList.remove('inview')
                this.container.querySelector('.navigation__section[data-navigation="'+dataNavigation+'"]').classList.remove('active')
                
            }
            // Mostro/nascondo il titoletto della sezione nella navigation bar
            if(this.container.querySelector('.sezione-navigation.inview') !== null){
                this.navigationCursor.classList.add('show')
            }
            else{
                this.navigationCursor.classList.remove('show')
            }
        })
    }
    setInviewOnHorizontalScroll(){
        this.sections.forEach( (section, i) => {
            let offset = winsize.width/2
            // let offset = 0
            const sectionDimension = this.sectionsWidths[i]
            const left = section.getBoundingClientRect().left
            let dataNavigation = section.getAttribute('data-navigation')
            if(left < winsize.width - offset  && left+sectionDimension >= winsize.width - offset ){
                section.classList.add('inview')
                this.sectionTarget = section
                this.container.querySelector('.navigation__section[data-navigation="'+dataNavigation+'"]').classList.add('active')
                this.moveCursor()
            }
            else{
                section.classList.remove('inview')
                this.container.querySelector('.navigation__section[data-navigation="'+dataNavigation+'"]').classList.remove('active')
                
            }

        })
    }

    setInviewOnClick(){
        this.navigationSections.forEach( navigationSection => {
            navigationSection.addEventListener('click', () => {
                if(this.isAnimating) return
                this.isAnimating = true
                document.querySelector('body').classList.add('click-on-navigation')
                const dataNavigation = navigationSection.getAttribute('data-navigation')
                this.sectionTarget = this.container.querySelector(`.sezione-navigation[data-navigation="${dataNavigation}"]`)
                awdScroll.scrollTo(this.sectionTarget, {
                    duration: 1200,
                    easing: [0.5, 0.00, 0.5, 1.00],
                    callback: () => {
                        setTimeout( () => {
                            navigationSection.classList.add('active')
                            this.navigationSections.forEach(sec => {
                                if(!sec.isSameNode(navigationSection)){
                                    sec.classList.remove('active')
                                }
                            })
                            document.querySelector('body').classList.remove('click-on-navigation')
                            this.isAnimating = false
                        },250)
                    }
                })
            })

        })

    }

    moveCursor(){
        let dataSectionTarget = this.sectionTarget.getAttribute('data-navigation')
        let navigationSectionTarget = this.navigation.querySelector(`.navigation__section[data-navigation="${dataSectionTarget}"]`)
        if(this.direction === 'vertical'){
            let offset = navigationSectionTarget.getBoundingClientRect().top - this.navigation.getBoundingClientRect().top
            gsap.to(this.navigationCursor,{
                duration: 0.8,
                y: offset,
                ease: 'power2.out'
            })
        }
        else{
            let offset = this.cursorDestinations[dataSectionTarget] - this.navigation.getBoundingClientRect().left - this.navigationCursor.getBoundingClientRect().width/2
            // console.log(offset)
            gsap.to(this.navigationCursor,{
                duration: 0.8,
                x: offset,
                ease: 'power2.out'
            })

        }
    }
}

export {NavigationBar}
